import clsx from 'clsx';
import { PlayerColor } from '../types';

interface CellProps {
    value: PlayerColor;
    onClick: () => void;
}

function Cell(props: CellProps) {
  const {value, onClick} = props;
  return (
    <div
      onClick={onClick}
      className={clsx(
        'w-6 h-6 border border-gray-400 flex items-center justify-center cursor-pointer',
        value === 'black' && 'bg-black rounded-full',
        value === 'white' && 'bg-white rounded-full border border-black',
        value === null && 'bg-gray-100'
      )}
    />
  );
}

export default Cell;